import { CASESUMMARYDETAILS } from "../constant/apiPath";
import { ccwpApi } from "@/services";

// Define a service using a base URL and expected endpoints
export const CaseSummaryApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCaseSummary: builder.query<any, any>({
      query: (caseId) => `${CASESUMMARYDETAILS}?id=${caseId}`,
    }),
    getCasePermission: builder.query<any, any>({
      query: (caseId) => `/Permissions/GetCasePermissions/${caseId}`,
    }),
    getAppPermission: builder.query<any, any>({
      query: () => `/Permissions/GetAppPermissions`,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCaseSummaryQuery, useLazyGetCaseSummaryQuery, useGetCasePermissionQuery, useLazyGetCasePermissionQuery,useGetAppPermissionQuery, useLazyGetAppPermissionQuery } =
  CaseSummaryApi;
